<form [formGroup]="updateUsernameForm" class="flex flex-col gap-1">
    <p class="font-bold">Username</p>
    <div class="flex flex-row gap-2">
        <input #usernameInput formControlName="username" class="p-1 bg-slate-100 rounded-sm shadow-sm grow disabled:text-slate-400">
        <button (click)="onChangeUsernameClicked()" class="w-[8ch] p-1 bg-slate-100 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="!canSubmitUsernameChange()">
            @if (!isUpdatingUsername) {
                Change
            } @else {
                <busy-spin [small]="true"></busy-spin>
            }
        </button>
    </div>
    @if (requireConfirmation) {
        <div class="flex flex-col p-2 gap-2 border border-ponder-link rounded bg-slate-100 shadow">
            <div>Please confirm your username change.</div>
            <div>This action can have unintended consequences such as breaking static links to your profile, decks, etc.</div>
            <div class="font-bold text-ponder-link">Are you sure you want to change your username to '{{ usernameInput.value }}'?</div>
            <div class="text-xs text-slate-400">You will be logged out upon successful username change.</div>
            <div class="flex flex-row justify-end gap-2">
                <button (click)="onCancelChangeUsernameClicked()" class="w-[8ch] p-1 bg-slate-100 rounded-sm hover:bg-slate-50 hover:shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent">
                    Cancel
                </button>
                <button (click)="onConfirmChangeUsernameClicked()" class="w-[8ch] p-1 bg-slate-50 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent">
                    Confirm
                </button>
            </div>
        </div>
    }
    @if (updatingUsernameError) {
        <div class="lex flex-col gap-1 border border-red-600 text-xs text-red-600 p-1 rounded">
            {{ updatingUsernameError }}
        </div>
    }
    <p class="text-xs text-slate-400">
        Used in the URL to route to your specific pages and for functionality such as <i>Add Friend</i>.
    </p>
</form>